import { useQuery } from '@apollo/client';
import {
  ALL_MODULES,
  AsyncPropSelector,
  T1,
  DateTimeFormatter,
  AppContext,
  DATE_FORMAT_FOR_DATE_PICKER,
  DATE_TIME_FORMAT,
  DATE_FORMAT
} from '@nile/components';
import { DisabledTag } from '@nile/mangifera/src/Pebbles/TicketContainer';
import DatePicker from 'react-datepicker';
import dayjs from 'dayjs';
import { Button, ButtonGroup, Popover } from '@superops/ui-design-system';
import { Edit } from '@styled-icons/material/Edit';
import { cloneDeep } from 'lodash';
import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import { EditIcon } from '@nile/components/src/Icons';

const CustomField = styled.div`
  min-width: 200px;
  max-width: ${(props) => (props?.fullWidth ? 'unset' : '250px')};
  flex-grow: 1;
  padding-right: ${(props) => !props?.fullWidth && '10px'};
  padding-left: ${(props) => !props?.fullWidth && '10px'};
  margin-top: 8px;
  margin-bottom: 8px;
  .Polaris-ButtonGroup {
    margin-top: 12px;
  }
  .inline {
    display: inline;
  }
`;

const Label = styled.div`
  text-align: left;
  font-weight: 500 !important;
  color: rgba(0, 0, 0, 0.6);
  margin-top: 10px;
`;

const Wrap = styled.div`
  display: flex;
  align-items: center;
  .edit-actions {
    visibility: hidden;
    cursor: pointer;
  }
  padding-left: 8px;
  padding-right: 8px;
  max-width: 100%;
`;

const CField = styled.div`
  .editable-cell,
  .cell {
    flex-grow: 1;
    font-weight: bold;
  }
  &:hover {
    .edit-actions {
      visibility: visible;
    }
  }
`;
function AsyncDate(props) {
  const {
    field,
    ticket,
    defaultValue,
    updateSelection,
    editable,
    value,
    inlineEdit,
    disableSelection,
    isMandatory
  } = props;

  const appContext = React.useContext(AppContext);

  const dateFormat = appContext?.company?.dateFormat || null;

  const [updatedValue, setUpdatedValue] = useState(value || null);
  const updateSelectedField = (val) => {
    updateSelection(val || null);
  };
  const [popoverActive, setPopoverActive] = useState(false);
  const togglePopoverActive = useCallback(() => {
    setPopoverActive(!popoverActive);
  });
  const updateUpdatedValue = (val) => {
    setUpdatedValue(val || null);
  };
  const getField = () => {
    const type = field.fieldType || field.uiDataType;
    switch (type) {
      case 'DATE':
      case 'date':
        return (
          <DatePicker
            selected={
              inlineEdit
                ? updatedValue
                  ? dayjs(updatedValue).toDate()
                  : ''
                : value
                ? dayjs(value).toDate()
                : ''
            }
            placeholderText="Choose date"
            onChange={
              inlineEdit
                ? (date) => {
                    updateUpdatedValue(
                      date ? dayjs(date).format(DATE_FORMAT) : ''
                    );
                  }
                : (date) =>
                    updateSelectedField(
                      date ? dayjs(date).format(DATE_FORMAT) : ''
                    )
            }
            dateFormat={
              dateFormat
                ? `${DATE_FORMAT_FOR_DATE_PICKER?.[dateFormat] || 'dd/MM/yyyy'}`
                : 'dd/MM/yyyy'
            }
            portalId="root-portal"
            disabled={disableSelection}
          />
        );
      case 'DATETIME':
      case 'datetime':
        return (
          <DatePicker
            selected={
              inlineEdit
                ? updatedValue
                  ? dayjs(updatedValue).toDate()
                  : ''
                : value
                ? dayjs(value).toDate()
                : ''
            }
            placeholderText="Choose date"
            onChange={
              inlineEdit
                ? (date) => {
                    updateUpdatedValue(
                      date ? dayjs(date).format(DATE_TIME_FORMAT) : ''
                    );
                  }
                : (date) => {
                    updateSelectedField(
                      date ? dayjs(date).format(DATE_TIME_FORMAT) : ''
                    );
                  }
            }
            dateFormat={
              dateFormat
                ? `${DATE_FORMAT_FOR_DATE_PICKER?.[dateFormat] ||
                    'dd/MM/yyyy'} hh:mm aa`
                : 'dd/MM/yyyy hh:mm aa'
            }
            showTimeInput
            portalId="root-portal"
            disabled={disableSelection}
          />
        );
      default:
    }
  };
  // if (loading) return <div>loading...</div>;
  const getTag = () => {
    return (
      <CustomField className="cf-wrapper">
        <Label className="cf-label">
          {field.label || ''}
          {isMandatory && (
            <>
              <span className="mandatory-star">*</span>
            </>
          )}
        </Label>
        {getField()}
        <div className="mt10">
          <ButtonGroup>
            <Button
              onClick={() => {
                togglePopoverActive();
                setUpdatedValue(value || '');
              }}
            >
              Cancel
            </Button>
            <Button
              primary
              onClick={() => {
                updateSelectedField(updatedValue);
                togglePopoverActive();
              }}
            >
              Save
            </Button>
          </ButtonGroup>
        </div>
      </CustomField>
    );
  };
  const type = field.fieldType || field.uiDataType;
  const displayVal = value ? (
    type === 'DATETIME' || type === 'datetime' ? (
      <DateTimeFormatter type="dateTime" date={value} />
    ) : (
      <DateTimeFormatter type="date" date={value} />
    )
  ) : (
    value
  );
  const activator = <EditIcon onClick={() => togglePopoverActive()} />;

  if (inlineEdit) {
    return !popoverActive ? (
      <CField>
        <Wrap className={`${editable ? 'editable-cell' : 'cell'}`}>
          <div className="ellipsis" title={displayVal}>
            {displayVal || <DisabledTag>NA</DisabledTag>}
          </div>
          {editable && <div className="edit-actions">{activator}</div>}
        </Wrap>
      </CField>
    ) : (
      <CField>
        <Wrap className="editable-cell">
          <div className="ellipsis" title={displayVal}>
            {displayVal || <DisabledTag>NA</DisabledTag>}
          </div>
          <Popover
            activator={activator}
            active={popoverActive}
            onClose={() => {
              // togglePopoverActive()
            }}
          >
            {getTag()}
          </Popover>
        </Wrap>
      </CField>
    );
  }
  return (
    <CustomField fullWidth={props?.fullWidth} className="cf-wrapper">
      <Label className="cf-label">
        <T1 className="inline">{field.label || ''}</T1>
        {isMandatory && (
          <>
            <span className="mandatory-star">*</span>
          </>
        )}
      </Label>
      <div
        className={`flex col ${props.error ? 'cf-error-state' : ''}`}
        key={field.name}
      >
        {getField()}
      </div>
    </CustomField>
  );
}

export default AsyncDate;
